<template>
  <div class="product-badge-description" v-if="(hasBadge && productBadgeDescription) || (hasSets && price < priceOld) || arrivalDate || (arrivalDateEmployee && isManager)">
    <div v-if="hasBadge && productBadgeDescription" v-html="productBadgeDescription"></div>
    <div v-else-if="!hasSets && price < priceOld" v-html="$t('fake_sales_badges_description')"></div>
    <div v-if="arrivalDate" v-html="arrivalDate"></div>
    <div v-if="arrivalDateEmployee && isManager">
      <br v-if="hasBadge">
      <span class="product-badge-description__arrival-date-employee" v-html="arrivalDateEmployee"></span>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'ProductBadgeDescription',
  computed: {
    ...mapGetters(['isManager']),
    ...mapState({
      hasSets: state => state.productInfo.productInfo.hasSets,
      hasBadge: state => state.productInfo.productInfo.hasBadge,
      price: state => state.productInfo.productInfo.price,
      priceOld: state => state.productInfo.productInfo.priceOld,
      productBadgeDescription: state => state.productInfo.productInfo.productBadgeDescription,
      arrivalDate: state => state.productInfo.productInfo.arrivalDate,
      arrivalDateEmployee: state => state.productInfo.productInfo.arrivalDateEmployee
    })
  }
}
</script>

<style scoped lang="sass">

.product-badge-description
  border: 1px solid
  border-image-slice: 1
  border-image-source: linear-gradient(91.12deg, #FF6838 7.12%, #FF7A00 101.34%)
  border-radius: 3px
  padding: 10px 30px
  margin-bottom: 40px

.product-badge-description__arrival-date-employee
  color: $main-color
  font-weight: 500

</style>
